export default {"src":"/_next/static/image/public/images/flags/flag_242.43ef072a94822ad645e0b370eea7d28c.svg","height":16,"width":24};